// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { IndexForms } from "@hex-insights/app-modules";
import { TypeFilterObject } from "@hex-insights/core";
import {
	AnnouncementSelectField,
	CalendarEventResponseSelectField,
	CalendarEventSelectField,
	MessageGroupArchivePointSelectField,
	MessageGroupSelectField,
	MessageSelectField,
	NewsletterSelectField,
	PermissionGroupSelectField,
	PostSelectField,
	SharingPolicySelectField,
	SocialCommentSelectField,
	SocialReactionSelectField,
	UserGroupSelectField,
	UserViewRecordSelectField,
} from "../../Forms";
import { UserFormValues } from "../../FormUtilities";
import { registry } from "../registry";
import * as CustomFilterFormValues from "./form-values-custom";

export type FilterFormValues = CustomFilterFormValues.StandardFilterFormValues &
	IndexForms.SearchFormValues &
	IndexForms.FilterFormValues;

export const initial: FilterFormValues = {
	...CustomFilterFormValues.initialStandardFilters,
	...IndexForms.initialSearchFormValues,
	...IndexForms.initialFilterFormValues,
};

export function getInitial(initialFormValues?: Partial<FilterFormValues>): FilterFormValues {
	return { ...initial, ...initialFormValues };
}

export const typeFilterObject: TypeFilterObject<FilterFormValues> = {
	...CustomFilterFormValues.standardFiltersTypeFilterObject,
	...IndexForms.searchFormValuesFilterObject,
	...IndexForms.filterFormValuesFilterObject,
};

export const advancedFilterInformation: IndexForms.AdvancedFilterInformation = {
	fieldOptions: [
		{ value: "givenName" },
		{ value: "middleName" },
		{ value: "familyName" },
		{ value: "nameOrder" },
		{ value: "publicNameFormat" },
		{ value: "organizationName" },
		{ value: "gender" },
		{ value: "pronouns" },
		{ value: "dateOfBirth" },
		{ value: "description" },
		{ value: "email" },
		{ value: "status" },
		{ value: "passwordUpdatedAt" },
		{ value: "isCurrent" },
		{ value: "timeZoneName" },
		{ value: "externalNotificationFrequency" },
		{ value: "authoredAnnouncements" },
		{ value: "authoredCalendarEventResponses" },
		{ value: "authoredCalendarEvents" },
		{ value: "authoredMessageGroupArchivePoints" },
		{ value: "authoredMessages" },
		{ value: "authoredNewsletters" },
		{ value: "authoredPosts" },
		{ value: "authoredSocialComments" },
		{ value: "authoredSocialReactions" },
		{ value: "memberGroups" },
		{ value: "messageGroups" },
		{ value: "permissionGroups" },
		{ value: "sharedSharingPolicies" },
		{ value: "sharingPolicies" },
		{ value: "userGroups" },
		{ value: "userViewRecords" },
	],
	fieldComparisonOptions: {
		givenName: IndexForms.stringComparisonOptions,
		middleName: IndexForms.stringComparisonOptions,
		familyName: IndexForms.stringComparisonOptions,
		nameOrder: IndexForms.enumComparisonOptions,
		publicNameFormat: IndexForms.enumComparisonOptions,
		organizationName: IndexForms.stringComparisonOptions,
		gender: IndexForms.stringComparisonOptions,
		pronouns: IndexForms.stringComparisonOptions,
		dateOfBirth: [...IndexForms.dateComparisonOptions, ...IndexForms.nullableComparisonOptions],
		description: IndexForms.stringComparisonOptions,
		email: IndexForms.stringComparisonOptions,
		status: IndexForms.enumComparisonOptions,
		passwordUpdatedAt: IndexForms.timeComparisonOptions,
		isCurrent: IndexForms.booleanComparisonOptions,
		timeZoneName: IndexForms.stringComparisonOptions,
		externalNotificationFrequency: IndexForms.enumComparisonOptions,
		authoredAnnouncements: IndexForms.multipleEdgeComparisonOptions,
		authoredCalendarEventResponses: IndexForms.multipleEdgeComparisonOptions,
		authoredCalendarEvents: IndexForms.multipleEdgeComparisonOptions,
		authoredMessageGroupArchivePoints: IndexForms.multipleEdgeComparisonOptions,
		authoredMessages: IndexForms.multipleEdgeComparisonOptions,
		authoredNewsletters: IndexForms.multipleEdgeComparisonOptions,
		authoredPosts: IndexForms.multipleEdgeComparisonOptions,
		authoredSocialComments: IndexForms.multipleEdgeComparisonOptions,
		authoredSocialReactions: IndexForms.multipleEdgeComparisonOptions,
		memberGroups: IndexForms.multipleEdgeComparisonOptions,
		messageGroups: IndexForms.multipleEdgeComparisonOptions,
		permissionGroups: IndexForms.multipleEdgeComparisonOptions,
		sharedSharingPolicies: IndexForms.multipleEdgeComparisonOptions,
		sharingPolicies: IndexForms.multipleEdgeComparisonOptions,
		userGroups: IndexForms.multipleEdgeComparisonOptions,
		userViewRecords: IndexForms.multipleEdgeComparisonOptions,
	},
	fieldComparisonTranslations: {
		givenName: IndexForms.stringComparisonTranslations,
		middleName: IndexForms.stringComparisonTranslations,
		familyName: IndexForms.stringComparisonTranslations,
		nameOrder: IndexForms.getRadioComparisonTranslations(UserFormValues.nameOrderOptions),
		publicNameFormat: IndexForms.getRadioComparisonTranslations(UserFormValues.publicNameFormatOptions),
		organizationName: IndexForms.stringComparisonTranslations,
		gender: IndexForms.stringComparisonTranslations,
		pronouns: IndexForms.stringComparisonTranslations,
		dateOfBirth: { ...IndexForms.dateComparisonTranslations, ...IndexForms.nullableComparisonTranslations },
		description: IndexForms.stringComparisonTranslations,
		email: IndexForms.stringComparisonTranslations,
		status: IndexForms.getRadioComparisonTranslations(UserFormValues.statusOptions),
		passwordUpdatedAt: IndexForms.timeComparisonTranslations,
		isCurrent: IndexForms.booleanComparisonTranslations,
		timeZoneName: IndexForms.stringComparisonTranslations,
		externalNotificationFrequency: IndexForms.getRadioComparisonTranslations(
			UserFormValues.externalNotificationFrequencyOptions,
		),
		authoredAnnouncements: IndexForms.getMultipleEdgeComparisonTranslations(
			AnnouncementSelectField.Select,
			AnnouncementSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredCalendarEventResponses: IndexForms.getMultipleEdgeComparisonTranslations(
			CalendarEventResponseSelectField.Select,
			CalendarEventResponseSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredCalendarEvents: IndexForms.getMultipleEdgeComparisonTranslations(
			CalendarEventSelectField.Select,
			CalendarEventSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredMessageGroupArchivePoints: IndexForms.getMultipleEdgeComparisonTranslations(
			MessageGroupArchivePointSelectField.Select,
			MessageGroupArchivePointSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredMessages: IndexForms.getMultipleEdgeComparisonTranslations(
			MessageSelectField.Select,
			MessageSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredNewsletters: IndexForms.getMultipleEdgeComparisonTranslations(
			NewsletterSelectField.Select,
			NewsletterSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredPosts: IndexForms.getMultipleEdgeComparisonTranslations(
			PostSelectField.Select,
			PostSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredSocialComments: IndexForms.getMultipleEdgeComparisonTranslations(
			SocialCommentSelectField.Select,
			SocialCommentSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		authoredSocialReactions: IndexForms.getMultipleEdgeComparisonTranslations(
			SocialReactionSelectField.Select,
			SocialReactionSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		memberGroups: IndexForms.getMultipleEdgeComparisonTranslations(
			UserGroupSelectField.Select,
			UserGroupSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		messageGroups: IndexForms.getMultipleEdgeComparisonTranslations(
			MessageGroupSelectField.Select,
			MessageGroupSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		permissionGroups: IndexForms.getMultipleEdgeComparisonTranslations(
			PermissionGroupSelectField.Select,
			PermissionGroupSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		sharedSharingPolicies: IndexForms.getMultipleEdgeComparisonTranslations(
			SharingPolicySelectField.Select,
			SharingPolicySelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		sharingPolicies: IndexForms.getMultipleEdgeComparisonTranslations(
			SharingPolicySelectField.Select,
			SharingPolicySelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		userGroups: IndexForms.getMultipleEdgeComparisonTranslations(
			UserGroupSelectField.Select,
			UserGroupSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		userViewRecords: IndexForms.getMultipleEdgeComparisonTranslations(
			UserViewRecordSelectField.Select,
			UserViewRecordSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
	},
};

registry.register("User", advancedFilterInformation, {
	authoredAnnouncements: "Announcement",
	authoredCalendarEventResponses: "CalendarEventResponse",
	authoredCalendarEvents: "CalendarEvent",
	authoredMessageGroupArchivePoints: "MessageGroupArchivePoint",
	authoredMessages: "Message",
	authoredNewsletters: "Newsletter",
	authoredPosts: "Post",
	authoredSocialComments: "SocialComment",
	authoredSocialReactions: "SocialReaction",
	memberGroups: "UserGroup",
	messageGroups: "MessageGroup",
	permissionGroups: "PermissionGroup",
	sharedSharingPolicies: "SharingPolicy",
	sharingPolicies: "SharingPolicy",
	userGroups: "UserGroup",
	userViewRecords: "UserViewRecord",
});
